//系统仓库
import { defineStore } from "pinia";
import { ref } from "vue";

export const sysStore = defineStore(
    "sysStore",
    () => {
        let sysName = ref(null);
        let sysVersion = ref(null);
        let sysColor = ref(null);
        let currentMenu = ref(null);
        let isLoading = ref(null);

        //设置系统信息
        const setSysName = (data) => {
            sysName.value = data;
        };
        const setSysVersion = (data) => {
            sysVersion.value = data;
        };
        const setSysColor = (data) => {
            sysColor.value = data;
        };
        const setCurrentMenu = (data) => {
            currentMenu.value = data;
        };
        const setIsLoading = (data) => {
            isLoading.value = data;
        };

        return {
            sysName,
            sysVersion,
            sysColor,
            currentMenu,
            isLoading,
            setSysName,
            setSysVersion,
            setSysColor,
            setCurrentMenu,
            setIsLoading
        };
    },
    {
        persist: {
            enabled: true,//是否开启持久化(需安装pinia-plugin-persistedstate插件)
            storage: sessionStorage,//持久化存储方式
        }
    }
);